import { render, staticRenderFns } from "./PatientInvitations.vue?vue&type=template&id=a10463aa&"
import script from "./PatientInvitations.vue?vue&type=script&lang=js&"
export * from "./PatientInvitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports